import { Component, OnInit, ViewChild } from '@angular/core';
import { InAppBrowser } from '@ionic-native/in-app-browser';
// import { CalendarComponentOptions } from 'ion2-calendar';
import { NavController, MenuController, LoadingController, ModalController, AlertController, Content, Events, App, Platform, ModalOptions } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { ServerService } from '../../services/server-service';
import { ToastService } from '../../services/toast-service';
import { NohehutPage } from '../nohehut/nohehut';
import { TabsPage } from '../tabs/tabs';
import moment from 'moment';

import { LocalNotifications } from '@ionic-native/local-notifications';


import {
  ChartReadyEvent, ChartErrorEvent, ChartSelectEvent,
  ChartMouseOverEvent, ChartMouseOutEvent
} from 'ng2-google-charts';
import { GoogleChartInterface } from 'ng2-google-charts/google-charts-interfaces';
import { AdmodalPage } from '../admodal/admodal';
import { getStoreRateLabel as resolveStoreRateLabel } from '../../services/store-rate';
import { ActivityPickerService } from '../../services/activity-picker.service';
import {
  isQuestionnaireSubmitted,
  openQuestionnaireModal,
} from '../../components/app-questionnaire/open-questionnaire-modal';
import { LoginPage } from '../login/login';
import { WebPushService } from '../../services/web-push.service';



@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage implements OnInit {
  matnasName: any = '';
  matnasImage: any = '';
  personalFullName: any = '';
  groups: any = [];
  notifications: any = [];
  missingReports: any = [];
  missingReportsLoading: boolean = true;
  futureActivitesLoading: boolean = true;
  newsLoading: boolean = true;
  hugRegDashLoading: boolean = true;
  birthdaysLoading: boolean = true;
  tasksLoading: boolean = true;
  vacationDaysLoading: boolean = true;
  skeletonSingle = [1];
  skeletonDouble = [1, 2];
  skeletonTriple = [1, 2, 3];
  showNotifications: boolean = false;
  matnasImageloaded: boolean = false;
  showMissingReports: boolean = false;
  futureActivitesList: any = [];
  showFutureActivites: boolean = false;
  mercazType: any = 0;
  hideTabsNohehut: boolean = false;
  mercazHideNohehut: any = 50;

  dailyPerBirthdays: any = [];
  showPerBirthdays: boolean = false;

  hugActivityDashData: any = [];
  hugActivityDashDataTwo: any = [];
  showHugRegDash: boolean = false;
  showHugRegDashTwo: boolean = false;
  hugRegTableRows: { hugName: string; meetingCount: number; barPercent: number }[] = [];
  hugRegTotal: number = 0;
  hugRegGraphLoading: boolean = true;
  hugActivityDashChartData: GoogleChartInterface;
  chartReady: boolean = false;

  showMentorTasks: boolean = false;
  initTasks: any = [];

  showVacationDays: boolean = false;
  vacationDays: any = [];

  showAbsentToday: boolean = false;
  absentToday: any[] = [];
  @ViewChild('pageTop') pageTop: Content;
  selectedLanguage = 'he';

  showRateStore: boolean = true;
  storeRateLabel: string = 'App Store';
  showQuestionnaire: boolean = true;

  // TRUE  -> modal opens every time you visit Home (ignores platform + localStorage gate)
  // FALSE -> production behaviour (cordova iOS/Android, once-per-device via localStorage)
  private readonly RATE_MODAL_TEST_MODE: boolean = false;

  constructor(public navCtrl: NavController,
    public menuCtrl: MenuController,
    private api: ServerService,
    private toast: ToastService,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    private alertCtrl: AlertController,
    public events: Events,
    private iab: InAppBrowser,
    public app: App,
    public platform: Platform,
    private localNotifications: LocalNotifications,
    private webPush: WebPushService,
    private activityPicker: ActivityPickerService,
    private translate: TranslateService,
  ) {
    this.matnasName = localStorage.getItem('mercazName');
    this.matnasImage = localStorage.getItem('mercazImage');
    this.personalFullName = localStorage.getItem('userName');
    this.selectedLanguage = localStorage.getItem('language') || this.translate.currentLang || 'he';
    this.events.subscribe('changeLanguage', (language?: string) => {
      if (language) {
        this.selectedLanguage = language;
      }
    });

    // this.menuCtrl.enable(false);
    // this.menuCtrl.swipeEnable(false);

    // this.navCtrl.setRoot(TabsPage,  {
    //   selectedIndex  : 3
    // })



  }

  onLanguageChange(ev: any) {
    const lang = ev && ev.target ? ev.target.value : '';
    if (!lang || lang === this.selectedLanguage) {
      return;
    }
    this.selectedLanguage = lang;
    this.translate.use(lang);
    localStorage.setItem('language', lang);
    this.events.publish('changeLanguage', lang);
    this.toast.presentToast(this.translate.instant('SettingsPage.popover.saved'));
  }

  get greetingKey(): string {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 12) {
      return 'HomePage.greeting.morning';
    }
    if (hour >= 12 && hour < 17) {
      return 'HomePage.greeting.afternoon';
    }
    if (hour >= 17 && hour < 22) {
      return 'HomePage.greeting.evening';
    }
    return 'HomePage.greeting.night';
  }

  public onMatnasImgError(ev: Event): void {
    const imgEl: any = ev && (ev.target as any);
    if (!imgEl) {
      return;
    }

    // prevent endless error loops
    imgEl.onerror = null;

    imgEl.src = 'assets/imgs/logo_no_bg.png';
  }




  goNehehut() {
    this.navCtrl.push('NohehutPage');
  }

  callSupport() {
    const browser = this.iab.create("tel:048727969", '_system');
  }

  goHugimPage() {
    this.navCtrl.push('HugimlistPage');
  }


  ngOnInit() {
    console.log("oninit");
  }

  ionViewDidEnter() {
    if (!this.platform.is('cordova')) {
      this.webPush.requestPermissionFromUser();
    }
  }





  loguserFunction() {
    this.beginHomeDataRefresh();
    let object = {
      "personalID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
      "pushToken": localStorage.getItem('push'),
    };
    // console.log("object:", object);
    this.api.sendPostParams('/log/logUser.php', object).then((data) => {
      this.getMissingReports();
    }, (err => {
      this.getMissingReports();
      console.log("error2:", JSON.stringify(err));

    }));
  }

  private beginHomeDataRefresh(): void {
    this.missingReportsLoading = true;
    this.futureActivitesLoading = true;
    this.newsLoading = true;
    this.hugRegDashLoading = true;
    this.birthdaysLoading = true;
    this.hugRegGraphLoading = true;
    this.tasksLoading = true;
    this.vacationDaysLoading = true;

    this.showMissingReports = false;
    this.showFutureActivites = false;
    this.showNotifications = false;
    this.showAbsentToday = false;
    this.showPerBirthdays = false;
    this.showVacationDays = false;
    this.showMentorTasks = false;
    this.showHugRegDash = false;
    this.showHugRegDashTwo = false;
    this.absentToday = [];
    this.notifications = [];
    this.missingReports = [];
    this.futureActivitesList = [];
    this.dailyPerBirthdays = [];
    this.vacationDays = [];
    this.initTasks = [];
    this.hugRegTableRows = [];
    this.hugRegTotal = 0;
  }

  getMissingReports() {
    let object = {
      "personalID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
      "pushToken": localStorage.getItem('push'),
    };
    // console.log("object:", object);
    this.missingReportsLoading = true;
    this.api.sendPostParams('/hugim/getMissingAtt.php', object).then((data) => {
      this.missingReportsLoading = false;
      if (data['sucsses']) {
        this.missingReports = data['missingAtt'];


        if (this.missingReports.length > 0) {
          this.showMissingReports = true;
        }
      }

      this.getFutureAcitivies();
    }, (err => {
      console.log("error2:", JSON.stringify(err));
      this.missingReportsLoading = false;
      this.getFutureAcitivies();
    }));
  }

  getFutureAcitivies() {
    let object = {
      "personalID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
      "pushToken": localStorage.getItem('push'),
    };
    // console.log("object:", object);
    this.futureActivitesLoading = true;
    this.api.sendPostParams('/hugim/getFutureAtt.php', object).then((data) => {
      // console.log("getFutureAcitivies", data);
      this.futureActivitesLoading = false;
      if (data['sucsses']) {
        this.futureActivitesList = data['futureActivites'];

        if (this.futureActivitesList.length > 0) {
          this.showFutureActivites = true;
        }
      }

      this.getNews();

    }, (err => {
      console.log("error2:", JSON.stringify(err));
      this.futureActivitesLoading = false;
      this.getNews();
    }));
  }

  getNews() {
    let object = {
      "personalID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
      "pushToken": localStorage.getItem('push'),
    };
    // console.log("object:", object);
    this.newsLoading = true;
    this.api.sendPostParams('/news/getNews.php', object).then((data) => {
      this.newsLoading = false;
      if (data['sucsses']) {

        this.notifications = data['notifications'];

        if (this.notifications.length > 0) {
          this.showNotifications = true;
        }

        this.absentToday = Array.isArray(data['absentToday']) ? data['absentToday'] : [];
        this.showAbsentToday = this.absentToday.length > 0;

        localStorage.setItem('personalImage', data['workerImage']);

        if (data['mercazName']) {
          this.matnasName = data['mercazName'];
          localStorage.setItem('mercazName', data['mercazName']);
        }

        // permission to send messages to participants - shown by default,
        // hidden only when the server explicitly returns allowPerMessages = false
        let allowPerMessages = data['allowPerMessages'];
        let blockPerMessages = !allowPerMessages;
        localStorage.setItem('allowPerMessages', blockPerMessages ? '0' : '1');

        if (data['mercazType']) {
          this.mercazType = data['mercazType'];
          localStorage.setItem('mercazType', data['mercazType']);

          if (this.mercazType == this.mercazHideNohehut) {
            this.hideTabsNohehut = true;
          }
        }

        let eventData = {
          "workerImage": data['workerImage'],
          "workerName": data['workerName'],
          "mercazType": data['mercazType'],
        }

        this.events.publish('userDataEvent', eventData);
        // this.events.publish('tabsEvent', eventData);


        if (data['workerFound'] === false) {
          let alertBox = this.alertCtrl.create({
            title: '<b>' + this.translate.instant('HomePage.blockedTitle') + '</b>',
            subTitle: '',
            buttons: [this.translate.instant('COMMON.ok')]
          });
          alertBox.present();

          localStorage.removeItem("mercazName");
          localStorage.removeItem("userName");
          localStorage.removeItem("user_id");
          localStorage.removeItem("mercazAllId");
          localStorage.removeItem("mercazImage");
          localStorage.removeItem("server");
          localStorage.removeItem("personalImage");
          localStorage.removeItem("mercazType");
          localStorage.removeItem("csvExportEmail");
          localStorage.removeItem("allowPerMessages");
          localStorage.setItem("beitEmonoalRamatGanServer", "0");
          if (!this.platform.is('cordova')) {
            this.webPush.resetHomeUserContext();
          }
          this.navCtrl.setRoot(LoginPage);
        } else {
          if (!this.platform.is('cordova')) {
            this.webPush.notifyHomeUserContextReady();
          }
        }


      }



      this.getHugAcitivityReg();

    }, (err => {
      console.log("error2:", JSON.stringify(err));
      this.newsLoading = false;
      this.getHugAcitivityReg();
    }));
  }


  getFutureDailyBirthdays() {
    let object = {
      "personalID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
      "pushToken": localStorage.getItem('push'),
    };
    // console.log("object:", object);
    this.birthdaysLoading = true;
    this.api.sendPostParams('/users/getDailyPerBirthdays.php', object).then((data) => {
      this.birthdaysLoading = false;
      if (data['sucsses']) {
        this.dailyPerBirthdays = data['dailyPerBirthdays'];


        if (this.dailyPerBirthdays.length > 0) {
          this.showPerBirthdays = true;
        }


      }
      this.getHugNerhamimGraph();
    }, (err => {
      console.log("error2:", JSON.stringify(err));
      this.birthdaysLoading = false;
      this.getHugNerhamimGraph();
    }));
  }


  getIntTasks() {
    let object = {
      "personalID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
      "pushToken": localStorage.getItem('push'),
    };
    // console.log("object:", object);
    this.tasksLoading = true;
    this.api.sendPostParams('/tasks/getOpenTasks.php', object).then((data) => {
      this.tasksLoading = false;
      if (data['sucsses']) {
        this.initTasks = data['mentorTasks'];
        if (this.initTasks.length > 0) {
          this.showMentorTasks = true;
        }
      }
      this.getVacationDays();
    }, (err => {
      console.log("error2:", JSON.stringify(err));
      this.tasksLoading = false;
      this.getVacationDays();
    }));
  }

  getVacationDays() {
    let object = {
      "personalID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
      "pushToken": localStorage.getItem('push'),
    };
    // console.log("object:", object);
    this.vacationDaysLoading = true;
    this.api.sendPostParams('/news/getVacationDays.php', object).then((data) => {
      console.log("getVacationDays", data);
      this.vacationDaysLoading = false;
      if (data['sucsses']) {
        this.vacationDays = data['results'];

        if (this.vacationDays.length > 0) {
          this.showVacationDays = true;
        }
      }
    }, (err => {
      console.log("error2:", JSON.stringify(err));
      this.vacationDaysLoading = false;
    }));
  }

  goParcipentMsg() {
    let loading = this.loadingCtrl.create({ content: this.translate.instant('COMMON.loading') });
    loading.present();
    let object = {
      "workerID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
    };

    // console.log("object:", object);

    this.api.sendPostParams('/users/getUserHugim.php', object).then(async (response: any) => {
      loading.dismiss();

      if (response['sucsses']) {

        if (response['userHugim'].length > 0) {
          const selectedHug = await this.activityPicker.pickOne(
            response['userHugim'],
            this.translate.instant('COMMON.pickActivity'),
            response['hugimShlohot'] || []
          );
          if (selectedHug) {
            this.navCtrl.push('PeractivitymsgPage', {
              hugID: selectedHug.hugID,
              hugName: selectedHug.hugName,
              type: selectedHug.type
            });
          }
        } else {
          this.toast.presentToast(this.translate.instant('HomePage.noActivitiesAssigned'));
        }

      } else {
        this.toast.presentServerError(response);
      }

    }, (err => {
      loading.dismiss();
      console.log("error2:", JSON.stringify(err));
      this.toast.presentHttpError(err);
    }));
  }

  goMeetingRegistrants() {
    let loading = this.loadingCtrl.create({ content: this.translate.instant('COMMON.loading') });
    loading.present();
    let object = {
      "workerID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
    };

    this.api.sendPostParams('/users/getUserHugim.php', object).then(async (response: any) => {
      loading.dismiss();

      if (response['sucsses']) {
        if (response['userHugim'].length > 0) {
          const selectedHug = await this.activityPicker.pickOne(
            response['userHugim'],
            this.translate.instant('COMMON.pickActivity'),
            response['hugimShlohot'] || []
          );
          if (selectedHug) {
            this.openMeetingRegistrantsModal(selectedHug);
          }
        } else {
          this.toast.presentToast(this.translate.instant('HomePage.noActivitiesAssigned'));
        }
      } else {
        this.toast.presentServerError(response);
      }
    }, (err => {
      loading.dismiss();
      console.log("error2:", JSON.stringify(err));
      this.toast.presentHttpError(err);
    }));
  }

  private openMeetingRegistrantsModal(selectedHug: any) {
    let loading = this.loadingCtrl.create({ content: this.translate.instant('COMMON.loadingRegistrants') });
    loading.present();
    const meetingDate = moment(new Date()).format('YYYY-MM-DD');
    const object = {
      "workerID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
      "hugID": selectedHug.hugID,
      "hugVskeytana": selectedHug.type,
      "reportDate": meetingDate,
    };

    this.api.sendPostParams('/users/getMeetingRegParticipants.php', object).then((response: any) => {
      loading.dismiss();
      if (!response || !response['sucsses']) {
        this.toast.presentServerError(response);
        return;
      }

      const participants = response['participants']
        || response['hugimParticipants']
        || response['meetingRegistrants']
        || [];

      this.modalCtrl.create('MeetingRegistrantsModalPage', {
        hugName: selectedHug.hugName,
        hugID: selectedHug.hugID,
        hugVskeytana: selectedHug.type,
        meetingDate: meetingDate,
        participants: participants,
      }, {
        cssClass: 'meeting-registrants-modal',
      }).present();
    }, (err => {
      loading.dismiss();
      console.log("error2:", JSON.stringify(err));
      this.toast.presentHttpError(err);
    }));
  }



  drawVisitsCount(eventsScannedata) {
    console.log("eventsScannedata:", eventsScannedata);
    console.log("eventsScannedata typeof:", typeof eventsScannedata);

    const rows = Array.isArray(eventsScannedata) ? eventsScannedata : [];
    if (rows.length === 0) {
      this.showHugRegDash = false;
      return;
    }

    this.showHugRegDash = true;

    let firstRow = [
      this.translate.instant('HomePage.chartActivityName'),
      this.translate.instant('HomePage.chartRegistrantCount'),
      { role: 'style' },
      { role: 'annotation' }
    ];

    let payload: any = [];
    payload.push(firstRow);
    rows.forEach(element => {
      let pushRow: any = [element['hugName'], element['meetingCount'], element['rowColor'], element['meetingCount']];
      payload.push(pushRow)
    });

    console.log("payload:", payload);

    this.hugActivityDashChartData = {
      chartType: 'BarChart',
      dataTable: payload,

      options: {
        "displayExactValues": true,
        'title': "", vAxis: { title: '' }, hAxis: { title: '' },
        legend: { position: 'top', alignment: 'end' },
        height: this.platform.height() * 0.3,
        width: this.platform.width()
      },
    };
  }

  drawHugRegGraph(eventsScannedata) {
    console.log("eventsScannedata:", eventsScannedata);
    console.log("eventsScannedata typeof:", typeof eventsScannedata);

    const rows = (Array.isArray(eventsScannedata) ? eventsScannedata : [])
      .filter(row => row && row.hugName != null);

    if (rows.length === 0) {
      this.showHugRegDashTwo = false;
      this.hugRegTableRows = [];
      this.hugRegTotal = 0;
      this.hugRegGraphLoading = false;
      return;
    }

    const counts = rows.map(row => Number(row.meetingCount) || 0);
    const maxCount = Math.max(...counts, 1);

    this.hugRegTableRows = rows.map((row, index) => {
      const meetingCount = counts[index];
      return {
        hugName: row.hugName,
        meetingCount,
        barPercent: Math.round((meetingCount / maxCount) * 100),
      };
    });
    this.hugRegTotal = counts.reduce((sum, count) => sum + count, 0);
    this.showHugRegDashTwo = true;
    this.hugRegGraphLoading = false;
  }


  getHugAcitivityReg() {
    this.chartReady = false;
    let object = {
      "personalID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
    };
    console.log("object:", object);
    this.hugRegDashLoading = true;
    this.api.sendPostParams('/dashboards/getHugimRegDash.php', object).then((data) => {
      this.hugRegDashLoading = false;
      if (data['sucsses']) {
        this.hugActivityDashData = data['meetingParList'];
      } else {
        this.hugActivityDashData = [];
      }
      this.drawVisitsCount(this.hugActivityDashData);
      this.getFutureDailyBirthdays();
    }, (err => {
      this.hugRegDashLoading = false;
      console.log("getHugAcitivityReg error:", err);
      this.drawVisitsCount([]);
      this.getFutureDailyBirthdays();
    }));
  }

  getHugNerhamimGraph() {
    this.chartReady = false;
    this.hugRegGraphLoading = true;
    let object = {
      "workerID": localStorage.getItem('user_id'),
      "mercazAllId": localStorage.getItem('mercazAllId'),
      "pqpq": localStorage.getItem('server'),
    };
    console.log("object:", object);
    this.api.sendPostParams('/dashboards/getHugRegGraph.php', object).then((data) => {
      if (data['sucsses']) {
        this.hugActivityDashDataTwo = data['hugimParticipants'];
      } else {
        this.hugActivityDashDataTwo = [];
      }
      this.drawHugRegGraph(this.hugActivityDashDataTwo);
      this.getIntTasks();
    }, (err => {
      console.log("getHugAcitivityReg error:", err);
      this.drawHugRegGraph([]);
      this.getIntTasks();
    }));
  }

  newReport(row) {
    if (row.hugVskeytana == 'hug') {
      this.navCtrl.push('NohehutreportPage', {
        hugID: row.hugID,
        hugName: row.hugName,
        type: row.hugVskeytana
      });
    }

  }

  onPieReady(event: ChartReadyEvent) {
    console.log("Chart ready:", event);
    this.chartReady = true;
  }

  chartError(error) {
    console.log("chart error:", error);
  }


  onPieReady2(event: ChartReadyEvent) {
    console.log("Chart ready2:", event);
  }

  chartError2(error) {
    console.log("chart error2:", error);
  }

  setHomeTab(index) {
    this.navCtrl.parent.select(index);
  }

  openNotification(row) {
    this.navCtrl.push('NotificationsPage', {
      item: row,
    });
  }

  goMonthlyBirthdays() {
    this.navCtrl.push('BirthdaysPage');
  }

  goAllOpenTasks() {
    this.navCtrl.push('MentortasksPage');
  }

  goHugimActivity() {
    this.navCtrl.push('HugimActivityPage', {}, {
      animate: true,
    });
  }

  goToForms() {
    this.navCtrl.push('FormsPage', {}, {
      animate: true,
    });
  }

  goToEvents() {
    this.navCtrl.push('EventsPage', {}, {
      animate: true,
    });
  }

  goToAbsentView() {
    this.navCtrl.push('AbsentViewPage', {}, {
      animate: true,
    });
  }

  formatAbsentDate(date: string): string {
    if (!date) {
      return '';
    }
    const formatted = moment(date).format('DD/MM/YY');
    return formatted !== 'Invalid date' ? formatted : date;
  }

  matnasImageloadedEvent() {
    this.matnasImageloaded = !this.matnasImageloaded;
  }

  openTasksPage(row) {
    this.navCtrl.push('TaskdetailsPage', {
      item: row,
    });
  }

  myNohehut() {
    this.navCtrl.push('MynohehutPage', {}, {
      animate: true,
    });
  }


  //set local push notification

  setLocalNotifcatiion() {

    if (this.platform.is('cordova')) {
      try {
        const twoHoursFromNow = new Date(new Date().getTime() + 2 * 60 * 60 * 1000);
        this.localNotifications.schedule({
          id: 1,
          title: this.translate.instant('HomePage.rateNotificationTitle'),
          text: this.translate.instant('HomePage.rateNotificationText'),
          trigger: { at: twoHoursFromNow },
          foreground: true,
          icon: 'file://assets/imgs/logo.png',
        });
      } catch (error) {
        // console.error('Error scheduling notification', error);
      }


      // Handle notification triggers
    }
  }

  /** One-time welcome local notification, ~10s after first Home load. */
  scheduleWelcomePush() {
    if (!this.platform.is('cordova')) {
      return;
    }
    try {
      if (localStorage.getItem('welcomePush') === '1') {
        return;
      }
      const inTenSeconds = new Date(new Date().getTime() + 10 * 1000);
      this.localNotifications.schedule({
        id: 2,
        title: this.translate.instant('HomePage.welcomeNotificationTitle'),
        text: this.translate.instant('HomePage.welcomeNotificationText'),
        trigger: { at: inTenSeconds },
        foreground: true,
        icon: 'file://assets/imgs/logo.png',
      });
      localStorage.setItem('welcomePush', '1');
    } catch (error) {
      // console.error('Error scheduling welcome notification', error);
    }
  }

  showAdModal() {

    let ShowAdModal = this.modalCtrl.create('AdmodalPage', {}, {
      cssClass: 'ad-app-modal',
      enableBackdropDismiss: false,
    });

    setTimeout(() => {
      ShowAdModal.present();
      // this.setLocalNotifcatiion();
    }, 2200);





  }

  checkIfShowAd() {
    let dateNow = moment().format("YYYY-MM-DD");
    let lastShownAdNew = localStorage.getItem("lastShownAdNew");

    if (!lastShownAdNew) {
      localStorage.setItem("lastShownAdNew", dateNow);
      this.showAdModal()
    }

    var today = moment().startOf('day')
    var createdDate = moment(lastShownAdNew, "YYYY-MM-DD").startOf('day')
    var diff = today.diff(createdDate, 'days')

    if (diff >= 60) {
      this.showAdModal();
      localStorage.setItem("lastShownAdNew", dateNow);
    }
  }

  isIosDevice(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor;
    // Check for modern iPads which might report as Mac
    const isMac = /Macintosh/i.test(userAgent);
    const isModernIpad = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    return isMac || isModernIpad;
  }

  ionViewDidLoad() {
    this.loguserFunction();

    //console.log("this.isIosDevice()", this.isIosDevice())

    // this.showAdModal();

    // if (!this.isIosDevice()) {
      this.checkIfShowAd();
    // }

    this.scheduleWelcomePush();

    this.showRateStore = this.isNativeStorePlatform();
    if (this.showRateStore) {
      this.storeRateLabel = this.getStoreRateLabel();
      this.maybeShowRateModal();
    }

    this.showQuestionnaire = !isQuestionnaireSubmitted();

    let storageMercazType: any = Number(localStorage.getItem('mercazType'));
    if (storageMercazType && storageMercazType == this.mercazHideNohehut) {
      this.hideTabsNohehut = true;
    }
  }

  private isNativeStorePlatform(): boolean {
    return this.platform.is('ios') || this.platform.is('android');
  }

  private getStoreRateLabel(): string {
    return resolveStoreRateLabel(this.platform);
  }

  private maybeShowRateModal() {
    if (!this.isNativeStorePlatform()) {
      return;
    }
    if (!this.RATE_MODAL_TEST_MODE) {
      try {
        if (localStorage.getItem('rateModalShownV1') === '1') {
          return;
        }

        const raw = localStorage.getItem('rateModalAppLaunches');
        const launches = raw ? parseInt(raw, 10) : 0;
        if (isNaN(launches) || launches < 2) {
          return;
        }
      } catch (e) {
        return;
      }
    }

    setTimeout(() => {
      // this.openRateAppModal();
    }, this.RATE_MODAL_TEST_MODE ? 800 : 2500);
  }

  openQuestionnaire() {
    openQuestionnaireModal(this.modalCtrl).then((data: any) => {
      if (data && data.submitted) {
        this.showQuestionnaire = false;
      }
    });
  }

  openRateAppModal() {
    const modal = this.modalCtrl.create('RateappmodalPage', {}, {
      cssClass: 'rate-app-modal',
      enableBackdropDismiss: false,
    });
    modal.onDidDismiss((data: any) => {
      if (this.RATE_MODAL_TEST_MODE) {
        return;
      }
      if (data && (data.rated || data.later || data.closed)) {
        try { localStorage.setItem('rateModalShownV1', '1'); } catch (e) { /* noop */ }
      }
    });
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts